import { CSSObject } from '@emotion/react'
import { Color, Spacing, Theme, Typography, OppositeTheme } from '@opallabs/gem'

export const wrapper = ({ theme }: { theme: Theme }): CSSObject => ({
  ...Typography.T500,
  color: Color[theme].Text.Default,
  display: 'flex',
  flexWrap: 'nowrap',
  gap: Spacing.S,
})

const checkSize = '1.15em'

export const input = ({ theme }: { theme: Theme }): CSSObject => ({
  appearance: 'none',
  backgroundColor: Color[theme].Surface.N000,
  border: `2px solid ${Color[OppositeTheme[theme]].Text.Gray}`,
  borderRadius: '50%',
  color: 'currentColor',
  cursor: 'pointer',
  display: 'grid',
  font: 'inherit',
  width: checkSize,
  height: checkSize,
  margin: '0',
  placeContent: 'center',
  transform: 'translateY(0.075em)',

  '&:hover:not(:disabled)': {
    '&::before': { backgroundColor: Color[theme].Surface.N100 },
    '&:checked::before': { backgroundColor: Color[theme].Surface.N100 },
  },

  '&:disabled': {
    cursor: 'not-allowed',
    opacity: '50%',
    '& + label': {
      cursor: 'not-allowed',
      opacity: '50%',
    },
  },

  '&::before': {
    content: '""',
    width: checkSize,
    height: checkSize,
    borderRadius: '50%',
    transform: 'scale(0)',
    border: `5px solid ${Color[theme].Surface.A200}`,
  },

  '&:checked::before': {
    transform: 'scale(1)',
  },
})
